import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Button } from 'primereact/button';
// import { toast } from 'react-toastify';
import cx from 'classnames';
import s from './Login.module.scss';

import { IRootState } from '../../reducers';
import { login, clearAuthentication, getSession } from '../../reducers/authentication';
import config from '../../config/constants';
import { stopPropagation } from '../../shared/utils/utils';

import { ReactComponent as IconLogo } from '../../icons/logo/logo-login.svg';

const initForm = { login: '', password: '' };
// eslint-disable-next-line @typescript-eslint/no-use-before-define
export interface IProps extends StateProps, DispatchProps, RouteComponentProps {}

export const Login: React.FC<IProps> = (props) => {
    const [formValue, setFormValue] = useState({ ...initForm });
    const formError = useRef(props.loginError);
    const { loading, location, isAuthenticated, loginError, error } = props;
    // @ts-ignore
    const { from } = location?.state || { from: { pathname: '/', search: location.search } };

    if (isAuthenticated && !location.search) {
        return <Redirect to={from} />;
    }

    const onChange = (ev) => {
        const { target } = ev;
        formError.current = false;
        setFormValue((value) => ({ ...value, [target.name]: target.value }));
    };

    const onSubmit = (ev) => {
        stopPropagation(ev);

        formError.current = true;
        props.login(formValue.login, formValue.password);
    };

    return (
        <>
            <div
                className={cx(s.container, {
                    disabled: loading,
                    [s.error]: loginError && formError.current,
                })}
            >
                <IconLogo className={s.icon} />

                <form onSubmit={onSubmit} className={s.form}>
                    <div className={s.title}>Вхід у обліковий запис</div>

                    <div className="cs-field">
                        <label>Логін</label>
                        <input
                            className="p-inputtext"
                            type="text"
                            name="login"
                            value={formValue.login}
                            onChange={onChange}
                            placeholder="Введіть ваш логін"
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="cs-field">
                        <label>Пароль</label>
                        <input
                            className="p-inputtext"
                            type="password"
                            name="password"
                            value={formValue.password}
                            onChange={onChange}
                            placeholder="Введіть ваш пароль"
                            autoComplete="new-password"
                        />
                    </div>

                    <div className={s.errorMsg}>
                        {error?.hasOwnProperty(props.lang) ? error[props.lang] : 'Не вірно вказаний логін або пароль'}
                    </div>

                    <Button
                        type="submit"
                        className={s.btnSubmit}
                        disabled={loading || !(formValue.login && formValue.password)}
                        label="Увійти"
                    />
                </form>
            </div>

            <div className={s.designedBy}>cnctr - delivery services hub by GNG </div>

            <div className="version">
                v{config.VERSION}
                {props.versionBE && <span> / BE v{props.versionBE}</span>}
            </div>
        </>
    );
};

const mapStateToProps = ({ auth, locale, config }: IRootState) => ({
    lang: locale.lang,
    isAuthenticated: auth.isAuthenticated,
    user: auth.user,
    versionBE: config.versionBE,
    loginError: auth.loginError,
    loading: auth.loading,
    error: auth.error,
});

const mapDispatchToProps = {
    login,
    clearAuthentication,
    getSession,
};

// eslint-disable-next-line no-undef
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

// @ts-ignore
export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(Login);
